import React, { useEffect, useState } from 'react';
import usecustomStyles from '../../Common/customStyles';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import ParticleAuth from '../../Common/ParticleAuth';
import { Facebook } from 'lucide-react';
import { GithubOutlined, GoogleOutlined, TwitterOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { registerUser, apiError, resetRegisterFlag } from '../../slices/thunk';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import logo from '../../assets/images/main_logo.png';
import NeedHelp from '../../Common/NeedHelp/NeedHelp';

const customStyles = usecustomStyles();

const StyleLine = styled.div`
  .signin-other-title {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      right: 0;
      border-top: 1px dashed #eff2f7;
      top: 10px;
    }
    .title {
      display: inline-block;
      position: relative;
      z-index: 9;
      background-color: #d0d0d0;
      padding: 2px 16px;
    }
  }
`;

const StyleWrapper = styled.div`
  background-color: ${({ theme }) => theme.token.authbgcolor};
`;

const Register = () => {
  // page title
  document.title = 'Register' + process.env.REACT_APP_PAGE_TITLE;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [timer, setTimer] = useState(0);
  const [loader, setLoader] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      phone: '',
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required('Please enter a valid phone number.')
        .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits.'),
    }),
    onSubmit: (values) => {
      dispatch(registerUser(values));
      setLoader(true);
    },
  });

  const selectAccount = createSelector(
    (state) => state.Account,
    (account) => ({
      success: account.success,
      error: account.error,
    })
  );

  const { error, success } = useSelector(selectAccount);

  useEffect(() => {
    dispatch(apiError());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      setTimeout(() => navigate('/login'), 3000);
      setTimer(3);
    }

    setTimeout(() => {
      dispatch(resetRegisterFlag());
    }, 3000);

    setLoader(false);
  }, [dispatch, success, error, navigate]);

  useEffect(() => {
    if (timer) {
      setInterval(() => setTimer((prevTimer) => prevTimer - 1), 1000);
    }
  }, [timer]);

  return (
    <StyleWrapper className="auth-page-wrapper">
      <NeedHelp />
      <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
        <Col xs={24} lg={14}>
          <Card className="parent_radius register">
            <Row gutter={[16, 24]} className="form_wrap">
              <Col xs={24} lg={7}>
                <ParticleAuth />
              </Col>
              <Col xs={24} lg={17}>
                <Card style={{ width: '100%' }} className="login_wrap">
                  <span>
                    <img src={logo} alt="logo" className="main_logo" />
                  </span>
                  <div className="text-center" style={{ marginTop: '20px' }}>
                    <h5 style={{ fontSize: 'calc(1.5vw + 5px)', color: customStyles.colorPrimary }}>
                      Create New Account
                    </h5>
                    <p style={{ fontSize: 'calc(.8vw + 3px)' }}>
                    List your business on Lumi Ads. Lets<br></br> start with a simple registration.                    </p>
                  </div>
                  <div
                    style={{
                      width: '100%',
                      maxWidth: '509px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="text-center">
                        <label htmlFor="phone" className="text_red d-block">
                          Mobile Number
                        </label>
                        <Input
                          name="phone"
                          placeholder="Ex: 9XX26XX65"
                          style={{
                            margin: '10px 0px',
                            color: '#9E9E9E',
                            textAlign: 'center',
                            boxShadow: 'none',
                            outline: 'none',
                            height: 'calc(1vw + 38px)',
                          }}
                          type="text"
                          value={validation.values.phone}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          status={validation.touched.phone && validation.errors.phone ? 'error' : ''}
                          maxLength={10}
                          onKeyDown={(e) => {
                            if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {validation.touched.phone && validation.errors.phone && (
                          <p style={{ color: customStyles.colorDanger , fontSize: '14px' , marginTop: "10px" , textAlign:" center" }}>{validation.errors.phone}</p>
                        )}
                      </div>
                      <div className="text-center">
                        <Button
                          htmlType="submit"
                          type="primary"
                          onClick={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            navigate('/multi-step-form')
                            return false;
                          }}
                          style={{
                            width: '50%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            marginTop: 'calc(2vw + 15px)',
                          }}
                          loading={loader}
                        >
                          Continue
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </StyleWrapper>
  );
};

export default Register;
